export const voiceChatPlatforms = [
  'discord',
  'line',
  'skype',
  'teamspeak',
  'other',
] as const

export type VoiceChatPlatform = (typeof voiceChatPlatforms)[number]

export const getVoiceChatPlatformDisplayName = (
  platform: VoiceChatPlatform
) => {
  switch (platform) {
    case 'discord':
      return 'Discord'
    case 'line':
      return 'LINE'
    case 'skype':
      return 'Skype'
    case 'teamspeak':
      return 'TeamSpeak'
    case 'other':
      return 'その他'
    default:
      return platform
  }
}
